import {loadScript} from 'coreUtils/utils';
import {IIdentityProviderCredentials} from '../IIdentityProvider';

/**
 * Represents IdentityProvider
 */
class IdentityProvider {
	protected config: Record<string, any>;
	public readonly isRedirectLogin: boolean = false;

	/**
	 * Returns current config
	 * @param {object} config provider configuration
	 */
	initConfig(config: Record<string, any>) {
		this.config = config;
	}

	/**
	 * Include sdk script tag
	 * @param {string} id id attribute of script tag
	 * @param {string} src link to sdk cdn
	 */
	async initScript(id, src) {
		await loadScript(src, id, {}, true);
	}

	/**
	 * Authenticate the user if there is no access
	 * in the browser session
	 * @returns {Promise} promise resolved when the auth process ends
	 */
	protected auth(): void {
		throw Error('You have to implement this method.');
	}

	/**
	 * Return the provider credentials
	 * @returns {IIdentityProviderCredentials|null} object containing credentials
	 */
	async getProviderCredentials(_data?: {search: URLSearchParams}): Promise<IIdentityProviderCredentials> {
		throw Error('You have to implement this method.');
	}

	/**
	 * Redirect to social provider login page
	 */
	async redirectToIdentityProvider(): Promise<void> {
		throw Error('You have to implement this method.');
	}

}

export default IdentityProvider;
